module.exports = __webpack_public_path__ + "static/img/love_img3.91ae0ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/love_img3.png
// module id = ANqT
// module chunks = 1